<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>시험 신청</p></li>
            <li><p>접수 확인 및 취소</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>접수 확인 및 취소</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="form_table">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl_big">
                    <p>
                      {{ item.exam.examinationName }}
                    </p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="id_picture_wrap">
                    <div class="inform_btn">
                      <button class="btn bo" @click="fnModalInfo">안내사항 확인</button>
                    </div>
                    <div class="id_picture">
                      <div class="thumb">
                        <div class="inner">
                          <!-- TODO: 이미지 불러오기 -->
                          <img :src="$ConstCode.getImagePath(item.userExam.userProfile)" alt="">
                        </div>
                        <p class="valid">유효성 문구 영역</p>
                        <!--'on 추가'-->
                      </div>
                      <div class="inform_box">
                        <div>
                          <span class="color bold">사진 안내</span>
                          <ol class="dot">
                            <li class="color">
                              <span class="ol_li_txt"
                                >사진은 3cmx4cm로 업로드 하시기 바랍니다.</span
                              >
                            </li>
                            <li class="color">
                              <span class="ol_li_txt"
                                >파일형식은 jpg, png만 가능합니다.</span
                              >
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>시험명</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.exam.examinationName }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>수험번호</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">
                      <span class="color bold">{{ item.userExam.examinationCode }}</span>
                    </p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>시험 구분</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.exam.rating }}급 {{ item.exam.part }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>시험 장소</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.exam.address }} {{ item.exam.address2 }}</p>
                  </div>
                </li>
                <li class="form_li top_bo">
                  <div class="form_ttl">
                    <p>이름(한글)</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userExam.koName }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>이름(영문)</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userExam.enName }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>생년월일</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userExam.userBirth }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>성별</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userExam.gender === 1 ? '남' : '여' }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>이메일</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userExam.email }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>주소</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userExam.postCode }}</p>
                    <p class="bind">{{ item.userExam.userAddr }}</p>
                    <p class="bind">{{ item.userExam.userAddr2 }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>휴대폰 번호</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userExam.userPhone }}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>자격 증명</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userExam.qualificationType === 1 ? '실무 경력' : '최종 학력' }}</p>
                  </div>
                </li>
                <div v-if="item.userExam.qualificationType === 1">
                  <li class="form_li">
                    <div class="form_ttl">
                      <p>담당 업무</p>
                    </div>
                    <div class="form_in">
                      <p class="bind">{{ item.userExam.work }}</p>
                    </div>
                  </li>
                  <li class="form_li">
                    <div class="form_ttl">
                      <p>근무 기간</p>
                    </div>
                    <div class="form_in">
                      <p class="bind">
                        {{ $moment(item.userExam.workStartDate).format('YYYY.MM.DD') }} ~ {{ $moment(item.userExam.workEndDate).format('YYYY.MM.DD') }}
                        ({{ monthToYear }})
                      </p>
                    </div>
                  </li>
                </div>
                <div v-else>
                  <li class="form_li">
                    <div class="form_ttl">
                      <p>자격 증명</p>
                    </div>
                    <div class="form_in">
                      <p class="bind">{{ academyType[item.userExam.academyType].label }}</p>
                    </div>
                  </li>
                  <li class="form_li">
                    <div class="form_ttl">
                      <p>학교(기관)명</p>
                    </div>
                    <div class="form_in">
                      <p class="bind">{{ item.userExam.academyName }}</p>
                    </div>
                  </li>
                  <li class="form_li">
                    <div class="form_ttl">
                      <p>전공(학과)</p>
                    </div>
                    <div class="form_in">
                      <p class="bind">{{ item.userExam.major }}</p>
                      <div class="inline">
                        <p class="bind">{{ completedType[item.userExam.completedType].label }}</p>
                      </div>
                    </div>
                  </li>
                </div>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>교육수료여부</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">{{ item.userExam.isSelected === 1 ? '지정기관 교육 수료' : ''}}
                      <span v-show="item.userExam.isSelected + item.userExam.isKfood === 2">,</span>&nbsp;
                      {{ item.userExam.isKfood === 1 ? '(사)한국외식산업협회 교육수료' : ''}}</p>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>파일 업로드</p>
                  </div>
                  <div class="form_in">
                    <p class="bind">
                      <span class="color bold">{{ item.userExam.fileName }}</span>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button class="btn bo grey" @click="() => $router.go(-1)">
            이전으로
          </button>
          <button class="btn" @click="fnModal">시험 취소하기</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manager-exam-register-view',
  description: '접수 확인 및 취소 상세',
  data: function() {
    const userExaminationNo = Number(this.$route.query.userExaminationNo)
    return {
      userExaminationNo,
      item: {},
      academyType: { // 학력
        1: { label: '대학원', value: 1 },
        2: { label: '대학교(4년제)', value: 2 },
        3: { label: '전문대(2년제)', value: 3 },
        4: { label: '고등학교', value: 4 },
        5: { label: '기타', value: 5 }
      },
      completedType: { // 전공수료타입
        1: { label: '졸업', value: 1 },
        2: { label: '재학', value: 2 },
        3: { label: '수료', value: 3 },
        4: { label: '중퇴', value: 4 }
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    userData() {
      return this.$store.getters['user/getUserData']
    },
    monthToYear: function() {
      const months = this.item.userExam.workMonth
      return (months / 12 | 0) + '년' + ( months % 12) + '개월'
    }
  },
  methods: {
    fetchData: async function() {
      const res = await this.$ManagerSvc.getMapUserExam({
        userExaminationNo: this.userExaminationNo
      })
      this.item = res.entity
    },
    fnModal: function() {
      const now = new Date();
      const year = now.getFullYear()
      let month = (1 + now.getMonth())
      month = month >= 10 ? month : '0' + month
      let day = now.getDate()
      day = day >= 10 ? day : '0' + day
      const currentDate = year + '' + month + '' + day
      if(this.item.exam.cancelDate < currentDate) {
        alert('취소 가능 일자 지나 취소할 수 없습니다.')
        return;
      }
      // 시험상태가 [교육취소] 일 경우
      if (this.item.userExam.examStatus === 3) {
        alert('취소 처리중입니다.')
        return false
      }
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.MODAL_EDU_CANCEL_POPUP,
        data: { examType: 2 },
        callBack: this.fnCancel
      })
    },
    fnCancel: async function(event, form) {
      form.userExaminationNo = this.userExaminationNo
      const res = await this.$ManagerSvc.patchIntExamCancel(form)
      if (res.code === 1) {
        alert('접수되었습니다.')
        this.$router.go(-1)
      } else {
        alert(res.message)
      }
    },
    fnModalInfo: function() {
      this.$store.commit('layout/setModalAlert', {
        modalAlertName: this.$modalAlertNames.MODAL_EXAM_INFO_POPUP,
        data: {},
        callBack: () => {}
      })
    }
  }
}
</script>

<style scoped></style>
